import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _PaymentAccount, _WithBankingNote } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Singleton } from "../../../../core/services/Singleton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectMonthPayment } from "./SelectMonthPayment";
import { SelectTypeProcees } from "./SelectTypeProcees";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BakingEntityEditor } from "../../../erp/cellEditor/BankingEntity/BankingEntitySelect";
import { SelectStateConst } from "./SelectStateConst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { Modal } from "../../../theme/Component/Modal";
import { PaymentAccountItem } from "./PaymentAccountItem";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { InputDate } from "../../../theme/Input/InputDate";
import { BankAccountSelect } from "../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { toast } from "react-toastify";
import { DocumentPDF, DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { CashDeskAccountSelector } from "../../../erp/cellEditor/CashDeskAccount/CashDeskAccountSelector";
import { Alert } from "../../../theme/Component/Alert";
import { DropDown } from "../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { BudgetResourceEditor } from "../../../admin/configuracion/BudgetResource/BudgetResource.Editor";
import { SelectBudgetSource } from "../../../admin/configuracion/BudgetSource/SelectBudgetSource";
import { AdminProcess } from "../../../erp/cellEditor/PaymentHeader/AdminProcess";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { Selecttofile } from "./Selecttofile";
import { BasicMultiSelectTable } from "../../../theme/Component/BasicMultiSelecTable";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { PaymentTurnEditor } from "../../../contract/PaymentTurn/PaymentTurnEditor";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { EditorBodegaDocumentos } from "../../../contabilidad/bodegaDocumentos/EditorBodegaDocumentos";


interface Props {
    CASH_REIMBURSEMENT?: number;
}

export const PaymentAccount = ({ CASH_REIMBURSEMENT }: Props) => {

    const { bean, setBean, lista, setLista, handleChange, instance, deleteItemVoid, update } = useDataBean(_PaymentAccount);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [form, setform] = useState<any>({
        IDPaymentTurn: null,
        IDDocument: null,
        DocumentDate: null,
    })
    const WithBankingNote = useDataBean(_WithBankingNote);
    const [docsEgress, setdocsEgrees] = useState<any>([]);
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [document, setDocument] = useState<any>([]);
    const [documentError, setDocumentError] = useState<any>([]);
    const [IdAcoount, setIdAcoount] = useState<any>(null);
    const [processType, setProcessType] = useState<any>(null);
    const [file, setFile] = useState<any>(null);
    const [idBudgetResource, setIDBudgetResource] = useState<any>(null);
    const [idBudgetSource, setIDBudgetSource] = useState<any>(null);
    const [idprocces, setIDProcces] = useState<any>(null);
    const [payment, setPayment] = useState<any>(null);
    const [operation, setOperation] = useState<any>(null);
    const [year, setyear] = useState<any>(null);
    const [month, setmonth] = useState<any>(null);
    const [state, setstate] = useState<any>(null);
    const [idBankingEntity, setidBankingEntity] = useState<any>(null);
    const [responseCash, setReponseCash] = useState<any>({});
    const [responseBank, setReponseBank] = useState<any>({});
    const [Register, SetRegister] = useState(15);
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [listaExport, setListaExport] = useState([]);
    const [modalCSV, setModalCSV] = useState<any>({ name: 'Detallado', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });
    const [listaResult, setListaResult] = useState<any>([]);
    const [listaIDResult, setListaIDResult] = useState<any>([]);
    const [modalrealizarpago, setModalrealizarpago] = useState<any>({ name: "Documentos Generados", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalVisor, setModalVisor] = useState<any>({ name: "Documentos Generados", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modaItemsCuenta, setItemsCuenta] = useState<any>({ name: 'Ver Items de la Cuenta por Pagar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalEgresoBanco, setEgresoBanco] = useState<any>({ name: 'Realizar Egreso por Bancos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalEgresoCaja, setEgresosCaja] = useState<any>({ name: 'Realizar Egreso por Caja', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalMultiBank, setModalMultiBank] = useState<any>({ name: 'Realizar Egreso Multiple por Banco', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalMultiCashDesk, setModalMultiCashDesk] = useState<any>({ name: 'Realizar Egreso Multiple por Caja', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [documentFilterKey, setDocumentFilterKey] = useState(0);
    const modalPayReport = useModal(`Reporte de cuentas por pagar`, MODAL_LG);

    const head = [
        { title: 'ID de Cuenta por Pagar', property: 'IDPaymentAccount', visible: true, mask: MASK_NUMBER },
        { title: 'Valor Total a Girar', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Beneficiario', property: 'AccountName', visible: true },
        { title: 'Documento/Proceso Fuente', property: 'SourceDocumentStr', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Turno de Pago', property: 'Turn', visible: true },
        { title: 'Vigencia Turno', property: 'TurnYear', visible: true },
        { title: 'Código Turno', property: 'TurnCode', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'Fuente de Cuenta', property: 'SourceTypeName', visible: true },
        { title: 'Tipo de Operación (Alternativo)', property: 'OperationType', visible: true },
        { title: 'Fecha Cuenta', property: 'ProcessDate', visible: true, mask: MASK_DATE },
        { title: 'Cuenta Consolida Terceros', property: 'RequiresConsolidateThird', visible: true },
        { title: 'Tipo de Proceso', property: 'TypeName', visible: true },
        { title: 'Estado de la Cuenta', property: 'StateName', visible: true },
        { title: 'Estado de la Operación', property: 'OperationStateName', visible: true },
        { title: 'Tipo de Cuenta Bancaria', property: 'AccountTypeName', visible: true },
        { title: 'Banco', property: 'EntityBanking', visible: true },
        { title: 'No Cuenta', property: 'AccountNumber', visible: true },
        { title: 'Método de Pago', property: 'EntityPayment', visible: true },
        // { title: 'CDP', property: 'CDPDocument', visible: false },
        // { title: 'RP', property: 'RPDocument', visible: false },
        { title: 'OB', property: 'OBDocument', visible: true },
        { title: 'CE', property: 'CEDocument', visible: true },
    ];

    const HeadToAdd = [
        { title: 'Valor Total a Girar', property: 'Value', visible: true },
    ];

    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        if (CASH_REIMBURSEMENT) {
            setProcessType(CASH_REIMBURSEMENT)
        }
        getLista();
    }, [CASH_REIMBURSEMENT])

    const getLista = () => {
        instance.getPaymentAccountList(form.IDPaymentTurn, file, idBudgetResource, idBudgetSource, idprocces, payment, operation, processType, null, IdAcoount, year, month, state, idBankingEntity, form.IDDocument, form.DocumentDate, paginador.page, Register).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.List)
                    let newList = resp.List;
                    if (newList.length > 0) {
                        newList.map((item) => {
                            item.DataBeanProperties.EntityBanking = ((item.DataBeanProperties.BankingEntityCode ?? "") + " - " + (item.DataBeanProperties.BankingEntityName ?? ""))
                            item.DataBeanProperties.EntityPayment = ((item.DataBeanProperties.PaymentTypeCode ?? "") + " - " + (item.DataBeanProperties.PaymentTypeName ?? ""))
                            item.DataBeanProperties.Turn = ((item.DataBeanProperties.IDPaymentTurn ?? "") + " - " + (item.DataBeanProperties.PaymentTurnDate ?? ""))
                            item.DataBeanProperties.SourceDocumentStr = 
                            item.DataBeanProperties.SourceDocument ? item.DataBeanProperties.SourceDocument :                            
                            ((item.DataBeanProperties.IDProcess ?? "") + " - " + (item.DataBeanProperties.ProcessDate ?? ""))
                        })
                    }
                    setLista(newList)
                    paginador.setPages(resp.NumberOfPages);
                }
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }
    const getListaExport = () => {
        instance.getPaymentAccountList(form.IDPaymentTurn, file, idBudgetResource, idBudgetSource, idprocces, payment, operation, processType, null, IdAcoount, year, month, state, idBankingEntity, form.IDDocument, form.DocumentDate, paginador.page, Register*15).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.List)
                    let newList = resp.List;
                    if (newList.length > 0) {
                        newList.map((item) => {
                            item.DataBeanProperties.EntityBanking = ((item.DataBeanProperties.BankingEntityCode ?? "") + " - " + (item.DataBeanProperties.BankingEntityName ?? ""))
                            item.DataBeanProperties.EntityPayment = ((item.DataBeanProperties.PaymentTypeCode ?? "") + " - " + (item.DataBeanProperties.PaymentTypeName ?? ""))
                            item.DataBeanProperties.Turn = ((item.DataBeanProperties.IDPaymentTurn ?? "") + " - " + (item.DataBeanProperties.PaymentTurnDate ?? ""))
                             item.DataBeanProperties.SourceDocumentStr = 
                            item.DataBeanProperties.SourceDocument ? item.DataBeanProperties.SourceDocument :                            
                            ((item.DataBeanProperties.IDProcess ?? "") + " - " + (item.DataBeanProperties.ProcessDate ?? ""))
                        })
                    }
                    setListaExport(newList)
                }
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const clearFilters = () => {
        const cleanProcessType = CASH_REIMBURSEMENT ?? null;

        setform({
            IDPaymentTurn: null,
            IDDocument: null,
            DocumentDate: null,
        });
        setFile(null);
        setIDBudgetResource(null);
        setIDBudgetSource(null);
        setIDProcces(null);
        setPayment(null);
        setOperation(null);
        setProcessType(cleanProcessType);
        setIdAcoount(null);
        setmonth(null);
        setstate(null);
        setidBankingEntity(null);
        setDocumentFilterKey((prev) => prev + 1);
        paginador.setPage(1);

        instance.getPaymentAccountList(null, null, null, null, null, null, null, cleanProcessType, null, null, year, null, null, null, null, null, 1, Register).then(
            (resp: any) => {
                if (resp) {
                    let newList = resp.List;
                    if (newList.length > 0) {
                        newList.map((item) => {
                            item.DataBeanProperties.EntityBanking = ((item.DataBeanProperties.BankingEntityCode ?? "") + " - " + (item.DataBeanProperties.BankingEntityName ?? ""))
                            item.DataBeanProperties.EntityPayment = ((item.DataBeanProperties.PaymentTypeCode ?? "") + " - " + (item.DataBeanProperties.PaymentTypeName ?? ""))
                            item.DataBeanProperties.Turn = ((item.DataBeanProperties.IDPaymentTurn ?? "") + " - " + (item.DataBeanProperties.PaymentTurnDate ?? ""))
                        })
                    }
                    setLista(newList)
                    paginador.setPages(resp.NumberOfPages);
                }
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const addCaja = () => {
        instance.createEgressDocumentByCashDeskAccount(responseCash.idCashDeskAccount, bean.IDPaymentAccount, responseCash.accountantDate, responseCash.Description, single.getAccountID(), null, null).then(
            (resp: any) => {
                //console.log(resp);
                if (resp.MsgList) {
                    setDocumentError(resp.MsgList);
                }
                if (resp.DocumentURL) {
                    let docs: DocumentPDF[] = [];
                    resp.DocumentURL.forEach(element => {
                        docs.push({
                            Filename: element.DataBeanProperties.Filename,
                            Media: element.DataBeanProperties.Media,
                            MediaContext: element.DataBeanProperties.MediaContext,
                            Type: element.DataBeanProperties.Type,
                            URLLink: element.DataBeanProperties.URLLink
                        })
                    });
                    setDocument(docs);
                }
                setModalVisor({ ...modalVisor, "view": true });
                setEgresosCaja({ ...modalEgresoCaja, "view": false });
            }
        ).catch(
            err => {
                console.error(err);
                toast.error("Algo salio mal")
            }
        )
    }



    const addBanco = () => {
        instance.createEgressDocumentByBankingAccount(responseBank.IDThirdBankingAccount, bean.IDPaymentAccount, responseBank.accountantDateBank, responseBank.Description, single.getAccountID(), null, null).then(
            (resp: any) => {
                //console.log(resp);
                if (resp.MsgList) {
                    setDocumentError(resp.MsgList);
                }
                if (resp.DocumentURL) {
                    let docs: DocumentPDF[] = [];
                    resp.DocumentURL.forEach(element => {
                        docs.push({
                            Filename: element.DataBeanProperties.Filename,
                            Media: element.DataBeanProperties.Media,
                            MediaContext: element.DataBeanProperties.MediaContext,
                            Type: element.DataBeanProperties.Type,
                            URLLink: element.DataBeanProperties.URLLink
                        })
                    });
                    setDocument(docs);
                }
                setModalVisor({ ...modalVisor, "view": true });
                setEgresoBanco({ ...modalEgresoBanco, "view": false })
            }
        ).catch(
            err => {
                console.error(err)
                toast.error("Algo salio mal")
            }
        )
    }

    const getECM = () => {
        instance.getECMAccountantDocumentForPaymentAccount(bean.IDPaymentAccount, bean.Since).then(
            (resp: any) => {
                console.log(resp);
                if (resp.MsgList) {
                    setDocumentError(resp.MsgList);
                }
                if (resp.DocumentURL) {
                    let docs: DocumentPDF[] = [];
                    resp.DocumentURL.forEach(element => {
                        docs.push({
                            Filename: element.DataBeanProperties.Filename,
                            Media: element.DataBeanProperties.Media,
                            MediaContext: element.DataBeanProperties.MediaContext,
                            Type: element.DataBeanProperties.Type,
                            URLLink: element.DataBeanProperties.URLLink
                        })
                    });
                    setDocument(docs);
                }
                setModalVisor({ ...modalVisor, "view": true, "name": "Ver Flujo de Aprobación" });
                setEgresoBanco({ ...modalEgresoBanco, "view": false })
            }
        ).catch(
            err => {
                console.error(err)
                toast.error(err)
            }
        )

    }

    const addMultiCaja = () => {
        if (responseCash.idCashDeskAccount && responseCash.accountantDate && listaIDResult.length > 0) {
            instance.createMultyEgressDocumentByCashDeskAccount(responseCash.idCashDeskAccount, listaIDResult, responseCash.accountantDate, responseCash.Description, single.getAccountID(), null, null).then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList > 0) {
                        setDocumentError(resp.MsgList);
                        setModalVisor({ ...modalVisor, "view": true })
                    }
                    setModalMultiBank({ ...modalMultiBank, "view": false });
                    setEgresosCaja({ ...modalEgresoCaja, "view": false });
                    getLista();
                }
            ).catch(
                err => {
                    console.error(err);
                    toast.error("Algo salio mal")
                }
            )
        } else {
            toast.error("Debe Seleccionar Caja, Fecha y al menos un Registo");
        }
    }



    const addMultiBanco = () => {
        if (responseBank.IDThirdBankingAccount && responseBank.accountantDateBank && listaIDResult.length > 0) {
            instance.createMultyEgressDocumentByBankingAccount(responseBank.IDThirdBankingAccount, listaIDResult, responseBank.accountantDateBank, responseBank.Description, single.getAccountID(), null, null).then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList > 0) {
                        setDocumentError(resp.MsgList);
                        setModalVisor({ ...modalVisor, "view": true })
                    }
                    getLista();
                    setModalMultiBank({ ...modalMultiBank, "view": false });
                    setEgresoBanco({ ...modalEgresoBanco, "view": false });
                }
            ).catch(
                err => {
                    console.error(err)
                    toast.error("Algo salio mal")
                }
            )
        } else {
            toast.error("Debe Seleccionar Banco, Fecha y al menos un Registo");
        }
    }

    const egresosOpenCahs = () => {
        setReponseCash({
            Description:bean.Description
        })
        setEgresosCaja({ ...modalEgresoCaja, "view": true });
    }

    const egresosOpenBank = () => {
        setReponseBank({
            Description:bean.Description
        })
        setEgresoBanco({ ...modalEgresoBanco, "view": true })
    }

    const validateDataCash = () => {
        if (validateFormCash() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            addCaja();
        }
    }

    const validateDataBank = () => {
        if (validateFormBank() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            addBanco();
        }
    }

    const validateFormCash = () => {
        const requiredFieldsCash = [
            "idCashDeskAccount", "accountantDate"
        ];


        let missing = [];

        for (let field of requiredFieldsCash) {
            if (responseCash[field] === null || responseCash[field] === undefined || responseCash[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        return missing.length
    };

    const validateFormBank = () => {

        const requiredFieldsBank = [
            "IDThirdBankingAccount", "accountantDateBank"
        ];

        let missing = [];

        for (let field of requiredFieldsBank) {
            if (responseBank[field] === null || responseBank[field] === undefined || responseBank[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        return missing.length
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Items de la Cuenta por Pagar', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => { setItemsCuenta({ ...modaItemsCuenta, "view": true }) } },
            { titulo: 'Realizar Pago de Obligación con Nota Débito Bancaria', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => { setModalrealizarpago({ ...modalrealizarpago, "view": true }) } },
            { titulo: 'Realizar Egreso por Caja', icono: 'ri-upload-line', visible: single.canEdit(), evento: () => { egresosOpenCahs() } },
            { titulo: 'Realizar Egreso por Banco', icono: 'ri-upload-2-line', visible: (bean.Type != 15), evento: () => { egresosOpenBank() } },
            { titulo: 'Ver Causación Contable', icono: 'ri-file-download-line', visible: bean.IDDocument, evento: () => { getDocument(bean.IDDocument, bean.Mnemonic, bean.DocumentDate, "Ver Causación Contable") } },
            { titulo: 'Ver Comprobante de Egreso', icono: 'ri-file-download-line', visible: bean.CEIDDocument, evento: () => { getDocument(bean.CEIDDocument, bean.CEMnemonic, bean.CEDate, "Ver Comprobante de Egreso") } },
            { titulo: 'Ver flujo de Aprobacion', icono: 'ri-file-download-line', visible: true, evento: () => { getECM() } },
            { titulo: 'Ver Obligación', icono: 'ri-file-download-line', visible: bean.OBMnemonic, evento: () => { getDocument(bean.IDDocument, bean.OBMnemonic, bean.OBDate, "Ver Obligación") } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [modal, setModal] = useState<any>({ name: 'Ver Comprobante de Ingreso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    const [docs, setDocs] = useState<any>([]);

    const getDocument = (idDoc: number, mnemonic: string, docDate: any, modalName: string) => {
        instance.getPdfAccountantDocument(idDoc, mnemonic, docDate).then(
            (resp) => {
                setDocs(resp);
                console.log(resp)
                setModal({ ...modal, "view": true, "name": modalName });
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const createEgressDocumentWithBankingNote = () => {

        WithBankingNote.instance.createEgressDocumentWithBankingNote(WithBankingNote.bean.IDBankingAccount, bean.IDPaymentAccount, WithBankingNote.bean.AccountantDate, WithBankingNote.bean.Description, _single.getAccountID(), null, null).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Creado');
                    setModalrealizarpago({ ...modalrealizarpago, "view": false });
                    setModaldoc({ ...modaldoc, "view": true });
                    setdocsEgrees(resp.DocumentURL);
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 4, name: 'Descargar Detallado Cuentas por pagar', permiso: null, activo: true },
        { id: 2, name: 'Egreso Masivo por Bancos', permiso: null, activo: true },
        { id: 3, name: 'Egreso Masivo por Caja', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {lista.length > 0 &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        )
    }

    const [reportView, setReportView] = useState<number>(1);

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            setModalCSV({ ...modalCSV, "view": true });
        } else if (e.id === 2) {
            getListaExport();
            setListaIDResult([]);
            setListaResult([])
            setModalMultiBank({ ...modalMultiBank, "view": true });
        } else if (e.id === 3) {
            getListaExport();
            setListaIDResult([]);
            setListaResult([]);
            setModalMultiCashDesk({ ...modalMultiCashDesk, "view": true });
        } else if (e.id === 4) {
            getListaExport();
            setListaIDResult([]);
            setListaResult([]);
            modalPayReport.open();
            setReportView(1);
        }
    }

    const headReportViews = [
        { title: 'ID de Cuenta por Pagar', property: 'IDPaymentAccount', visible: true, mask: MASK_NUMBER },
        // { title: 'Turno de Pago', property: 'Turn', visible: false },
        // { title: 'Vigencia Turno', property: 'TurnYear', visible: false },
        // { title: 'Código Turno', property: 'TurnCode', visible: false },
        { title: 'Valor Total a Girar', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Beneficiario', property: 'AccountName', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'Fuente de Cuenta', property: 'SourceTypeName', visible: true },
        { title: 'Tipo de Operación (Alternativo)', property: 'OperationType', visible: true },
        { title: 'Fuente', property: 'SourceDocument', visible: true },
        { title: 'Fecha Cuenta', property: 'ProcessDate', visible: true, mask: MASK_DATE },
        { title: 'Cuenta Consolida Terceros', property: 'RequiresConsolidateThird', visible: true },
        { title: 'Tipo de Proceso', property: 'TypeName', visible: true },
        { title: 'Estado de la Cuenta', property: 'StateName', visible: true },
        { title: 'Estado de la Operación', property: 'OperationStateName', visible: true },
        { title: 'Tipo de Cuenta Bancaria', property: 'AccountTypeName', visible: true },
        { title: 'Banco', property: 'EntityBanking', visible: true },
        { title: 'No Cuenta', property: 'AccountNumber', visible: true },
        { title: 'Método de Pago', property: 'EntityPayment', visible: true },
        { title: 'CDP', property: 'CDPDocument', visible: true },
        { title: 'RP', property: 'RPDocument', visible: true },
        { title: 'OB', property: 'OBDocument', visible: true },
        { title: 'CE', property: 'CEDocument', visible: true },
    ];

    return (
        <>
            <BasicPage titulo="Cuentas por Pagar">
                <div className="row">
                    <div className="col-md-6">
                        <YearSelector value={year} onChange={setyear} />
                    </div>

                    <div className="col-md-6">
                        <SelectMonthPayment label="Mes" idSelector={month} onChange={(e) => { setmonth(e) }} />
                    </div>
                    <div className="col-md-6">
                        <Selecttofile idSelector={file} onChange={(e) => { setFile(e) }} />
                    </div>
                    <div className="col-md-6">
                        <BudgetResourceEditor label='Recurso Presupuestal' idSelector={idBudgetResource} onChange={(e) => { setIDBudgetResource(e) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectBudgetSource label='Fuente de Financiamiento' idSelector={idBudgetSource} onChange={(e) => { setIDBudgetSource(e) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectTypeProcees disable={CASH_REIMBURSEMENT ? true : false} label="Tipo de Proceso" idSelector={processType} onChange={(e) => setProcessType(e)} />
                    </div>

                    <div className="col-md-6">
                        {processType}
                        <AdminProcess returnType="Object" idSelector={idprocces} onChange={(e) => { console.log(e); setIDProcces(e.IDProcess) }} />
                    </div>

                    <div className="col-md-6">
                        <label>No Cuenta por Pagar</label>
                        <input type="text" className="form-control" value={payment} onChange={(e) => { setPayment(parseFloat(e.target.value)) }} />
                    </div>

                    <div className="col-md-6">
                        <label>Tipo de Operación</label>
                        <input type="text" className="form-control" value={operation} onChange={(e) => { setOperation(parseFloat(e.target.value)) }} />
                    </div>

                    <div className="col-md-6">
                        <AccountEditor label="Beneficiario" idAccount={IdAcoount} onChange={(e) => { setIdAcoount(e.IDAccount) }} />
                    </div>
                    <div className="col-md-6">
                        <BakingEntityEditor label="Entidad Bancaria" idSelector={idBankingEntity} onChange={(e) => { setidBankingEntity(e) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Turnos de Pago de Cuentas por Pagar</label>
                        <PaymentTurnEditor render={form.IDPaymentTurn} idSelector={form.IDPaymentTurn} onChange={(e) => { setform({ ...form, "IDPaymentTurn": e.IDPaymentTurn }) }} label=" " returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <SelectStateConst label="Estado" idSelector={state} onChange={(e) => { setstate(e); console.log(e) }} />
                    </div>

                    <div className="col-md-6">
                        <EditorBodegaDocumentos configProps={{ label: 'Documento Fuente' }} key={documentFilterKey} onChange={(e) => { setform({ ...form, "IDDocument": e.IDDocument, "DocumentDate": e.DocumentDate }) }} />
                    </div>

                    <div className="col-md-6">
                        <label>Cantidad Registro por pagina</label>
                        <input type="number" name="Value" className="form-control" value={Register} onChange={(e) => { SetRegister(parseInt(e.target.value)) }} />
                    </div>
                    <div className="col-md-6 d-flex justify-content-around">
                        <BasicButton icon="ri-search-line" useMargin eventClick={getLista}>Buscar</BasicButton>
                        <BasicButton icon="ri-filter-off-line" useMargin clase="secondary" eventClick={clearFilters}>Quitar filtros</BasicButton>
                    </div>
                </div>

                <BasicTable

                    headButtons={buttons()}
                    customRows={Register}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    records={paginador}
                ></BasicTable>
            </BasicPage>

            <Modal modal={modaItemsCuenta} updateModal={setItemsCuenta}>
                <PaymentAccountItem IDPaymentAccount={bean.IDPaymentAccount} />
            </Modal>
            <Modal modal={modalrealizarpago} updateModal={setModalrealizarpago} eventModal={createEgressDocumentWithBankingNote}>
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <BankAccountSelect label="Banco Orígen" idSelector={WithBankingNote.bean.IDBankingAccount} onChange={(e) => { WithBankingNote.setBean({ ...WithBankingNote.bean, "IDBankingAccount": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="AccountantDate" label="Fecha de Registro Contable" value={WithBankingNote.bean.AccountantDate} setDate={(e: any) => { WithBankingNote.setBean({ ...WithBankingNote.bean, "AccountantDate": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Description" className="form-control" value={WithBankingNote.bean.Description} onChange={WithBankingNote.handleChange} />
                        </div>
                    </div>
                </>
            </Modal>

            <Modal modal={modaldoc} updateModal={setModaldoc}>
                <div className="row">
                    <div className="col-md-12">
                        <DocumentViewer
                            list={docsEgress}
                        />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalEgresoCaja} updateModal={setEgresosCaja} eventModal={validateDataCash}>
                <div className="row">
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('idCashDeskAccount') ? 'has-error' : ''}`}>Caja Menor</label>
                        <CashDeskAccountSelector id={responseCash.idCashDeskAccount} onchange={(e) => { setReponseCash({ ...responseCash, "idCashDeskAccount": e }) }} label=' ' />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('accountantDate') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                        <InputDate notDate label=' ' name='accountantDate' value={responseCash.accountantDate} setDate={(e: any) => { setReponseCash({ ...responseCash, "accountantDate": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Description</label>
                        <textarea name="Description" className="form-control" value={responseCash.Description} onChange={(e) => { setReponseCash({ ...responseCash, "Description": String(e.target.value) }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalEgresoBanco} updateModal={setEgresoBanco} eventModal={validateDataBank}>
                <div className="row">
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDThirdBankingAccount') ? 'has-error' : ''}`}>Banco</label>
                        <BankAccountSelect idSelector={responseBank.IDThirdBankingAccount} onChange={(e) => { setReponseBank({ ...responseBank, "IDThirdBankingAccount": e }) }} label=' ' />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('accountantDateBank') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                        <InputDate notDate label=' ' name='accountantDate' value={responseBank.accountantDateBank} setDate={(e: any) => { setReponseBank({ ...responseBank, "accountantDateBank": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={responseBank.Description} onChange={(e) => { setReponseBank({ ...responseBank, "Description": String(e.target.value) }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalMultiCashDesk} updateModal={setModalMultiCashDesk} eventModal={() => { addMultiCaja() }}>
                <div className="row">
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('idCashDeskAccount') ? 'has-error' : ''}`}>Caja Menor</label>
                        <CashDeskAccountSelector id={responseCash.idCashDeskAccount} onchange={(e) => { setReponseCash({ ...responseCash, "idCashDeskAccount": e }) }} label=' ' />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('accountantDate') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                        <InputDate notDate label=' ' name='accountantDate' value={responseCash.accountantDate} setDate={(e: any) => { setReponseCash({ ...responseCash, "accountantDate": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Description</label>
                        <textarea name="Description" className="form-control" value={responseCash.Description} onChange={(e) => { setReponseCash({ ...responseCash, "Description": String(e.target.value) }) }} />
                    </div>
                    <div className="col-md-12 mt-2">
                        <BasicMultiSelectTable
                            keyId="IDPaymentAccount"
                            clearnotListBody
                            body={listaExport.filter(item => !item.DataBeanProperties?.CEIDDocument)}
                            bodyResult={listaResult}
                            head={head}
                            sumPropsList={HeadToAdd}
                            updateValues={({ bodyResult }) => {
                                const filteredIds = bodyResult.map(item => item.DataBeanProperties.IDPaymentAccount);
                                setListaResult(bodyResult);
                                setListaIDResult(filteredIds)
                            }}
                        />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalMultiBank} updateModal={setModalMultiBank} eventModal={() => { addMultiBanco() }}>
                <div className="row">
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDThirdBankingAccount') ? 'has-error' : ''}`}>Banco</label>
                        <BankAccountSelect idSelector={responseBank.IDThirdBankingAccount} onChange={(e) => { setReponseBank({ ...responseBank, "IDThirdBankingAccount": e }) }} label=' ' />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('accountantDateBank') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                        <InputDate notDate label=' ' name='accountantDate' value={responseBank.accountantDateBank} setDate={(e: any) => { setReponseBank({ ...responseBank, "accountantDateBank": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={responseBank.Description} onChange={(e) => { setReponseBank({ ...responseBank, "Description": String(e.target.value) }) }} />
                    </div>
                    <div className="col-md-12 mt-2">
                        <BasicMultiSelectTable
                            keyId="IDPaymentAccount"
                            clearnotListBody
                            body={listaExport.filter(item => !item.DataBeanProperties?.CEIDDocument)}
                            bodyResult={listaResult}
                            head={head}
                            updateValues={({ bodyResult }) => {
                                const filteredIds = bodyResult.map(item => item.DataBeanProperties.IDPaymentAccount);
                                setListaResult(bodyResult);
                                setListaIDResult(filteredIds)
                                console.log(bodyResult)
                            }}
                            sumPropsList={HeadToAdd}
                        />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalPayReport.modal} updateModal={modalPayReport.setModal} buttonsAddFooter={
                <>
                    {reportView === 1 &&
                        <BasicButton eventClick={() => { setReportView(2) }} icon="" children={`Descargar Detallado`} />
                    }
                </>
            } >
                <div className="row">
                    {reportView === 1 &&
                        <div className="col-md-12">
                            <BasicMultiSelectTable
                                keyId="IDPaymentAccount"
                                clearnotListBody
                                body={listaExport.filter(item => !item.DataBeanProperties?.CEIDDocument)}
                                bodyResult={listaResult}
                                head={headReportViews}
                                updateValues={({ bodyResult }) => {
                                    const filteredIds = bodyResult.map(item => item.DataBeanProperties.IDPaymentAccount);
                                    setListaResult(bodyResult);
                                    setListaIDResult(filteredIds)
                                    console.log(bodyResult)
                                }}
                                sumPropsList={HeadToAdd}
                            />
                        </div>
                    }

                    {reportView === 2 &&
                        <>
                            {listaResult.length > 0 ?
                                <ExportXLSL customName={"CuentasXPagar"} optionIcon="ri-download-cloud-2-line text-success" title={headReportViews} data={listaResult} onExport={(name: string) => {
                                    single.download("formato xlsx [" + name + "] con " + listaResult.length + " registros");
                                }} />
                                :
                                <Alert clase="Info">Sin datos seleccionados <a onClick={() => { setReportView(1) }} >Click Aqui para volver</a></Alert>
                            }
                        </>
                    }
                </div>
            </Modal>

            <Modal modal={modalVisor} updateModal={setModalVisor} >
                <div className="row">
                    <div className="col-md-12">
                        {documentError.length > 0 ?
                            <>
                                <ul className="group-list">
                                    {documentError.map((item: any, index: number) => {
                                        return (
                                            <li key={index} className="group-list-item">{item}</li>
                                        )
                                    })}
                                </ul>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                            :
                            <>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>

            <Modal modal={modal} updateModal={setModal} >
                {docs.length > 0 ?
                    <DocumentViewer list={docs} />
                    :
                    <Alert children={"No se geenero ningun documento"} clase="warning text-center" />
                }
            </Modal>
            <Modal modal={modalCSV} updateModal={setModalCSV}>
                <div className="row">
                    <div className="col">
                        {lista.length > 0 &&
                            <ExportXLSL customName={"CuentasXPagar"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                single.download("formato xlsx [" + name + "] con " + listaExport.length + " registros");
                            }} />
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}
